module.exports = __webpack_public_path__ + "img/img_joinstep_money.f1df9c0a.svg";